import { schema } from 'normalizr';

export const session = new schema.Entity('sessions');
export const sessionList = [session];



// WEBPACK FOOTER //
// ./src/modules/sessions/schema.js